export default __webpack_public_path__ + "static/media/sentroBanner.de1d5a26.png";